export default {
  feeds: [],
  pagination: {},
  feed: {}
}
